import { render, staticRenderFns } from "./ThePageWeapons.vue?vue&type=template&id=860e3240&scoped=true&"
import script from "./ThePageWeapons.vue?vue&type=script&lang=js&"
export * from "./ThePageWeapons.vue?vue&type=script&lang=js&"
import style0 from "./ThePageWeapons.vue?vue&type=style&index=0&id=860e3240&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e3240",
  null
  
)

export default component.exports